/**
 * Utility function for determining if a value is "nullish"
 * (null or undefined)
 */
export const isNullish = (x: unknown): x is null | undefined =>
    x === null || typeof x === 'undefined'

/**
 * Utility function for determining if a value is not "nullish"
 * (null or undefined)
 */
export const isNotNullish = <T>(x: T | null | undefined): x is T => !isNullish(x)
